import {
  VENDOR_PRODUCTS_LIST,
  VENDOR_PRODUCTS_LOADING,
  VENDOR_PRODUCTS_ERROR,
  VENDOR_PRODUCT_DETAIL,
  VENDOR_PRODUCT_DETAIL_LOADING,
  VENDOR_PRODUCT_DETAIL_ERROR,
  VENDOR_PRODUCT_MUTATION_LOADING,
  VENDOR_PRODUCT_MUTATION_ERROR,
  VENDOR_PRODUCT_SECTORS,
  VENDOR_PRODUCT_SECTORS_LOADING,
  VENDOR_PRODUCT_SECTORS_ERROR,
  VENDOR_PRODUCT_SECTOR_ITEMS,
  VENDOR_PRODUCT_SECTOR_LOADING,
  VENDOR_PRODUCT_SECTOR_ERROR,
} from "../actions/type";

const initialState = {
  items: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  loading: false,
  error: "",
  detail: null,
  detailLoading: false,
  detailError: "",
  mutationLoading: false,
  mutationError: "",
  sectors: [],
  sectorsLoading: false,
  sectorsError: "",
  sectorProducts: {},
  sectorProductsLoaded: {},
  sectorProductsLoading: {},
  sectorProductsError: {},
};

export default function vendorProduct(state = initialState, action) {
  switch (action.type) {
    case VENDOR_PRODUCTS_LIST:
      return { ...state, ...action.payload };
    case VENDOR_PRODUCTS_LOADING:
      return { ...state, loading: action.payload };
    case VENDOR_PRODUCTS_ERROR:
      return { ...state, error: action.payload };
    case VENDOR_PRODUCT_DETAIL:
      return { ...state, detail: action.payload };
    case VENDOR_PRODUCT_DETAIL_LOADING:
      return { ...state, detailLoading: action.payload };
    case VENDOR_PRODUCT_DETAIL_ERROR:
      return { ...state, detailError: action.payload };
    case VENDOR_PRODUCT_MUTATION_LOADING:
      return { ...state, mutationLoading: action.payload };
    case VENDOR_PRODUCT_MUTATION_ERROR:
      return { ...state, mutationError: action.payload };
    case VENDOR_PRODUCT_SECTORS:
      return { ...state, sectors: action.payload };
    case VENDOR_PRODUCT_SECTORS_LOADING:
      return { ...state, sectorsLoading: action.payload };
    case VENDOR_PRODUCT_SECTORS_ERROR:
      return { ...state, sectorsError: action.payload };
    case VENDOR_PRODUCT_SECTOR_ITEMS:
      return {
        ...state,
        sectorProducts: {
          ...state.sectorProducts,
          [action.payload.sectorId]: action.payload.items,
        },
        sectorProductsLoaded: {
          ...state.sectorProductsLoaded,
          [action.payload.sectorId]: true,
        },
      };
    case VENDOR_PRODUCT_SECTOR_LOADING:
      return {
        ...state,
        sectorProductsLoading: {
          ...state.sectorProductsLoading,
          [action.payload.sectorId]: action.payload.loading,
        },
      };
    case VENDOR_PRODUCT_SECTOR_ERROR:
      return {
        ...state,
        sectorProductsError: {
          ...state.sectorProductsError,
          [action.payload.sectorId]: action.payload.error,
        },
      };
    default:
      return state;
  }
}
